export default __webpack_public_path__ + "static/avatar-matt-hancock-0726211bf5ad5ebd39f3f88fc2990cbe.jpg";